import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function PercentIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18639_3226)">
          <path
            d="M15.625 4.375L4.375 15.625"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.9375 8.125C7.14562 8.125 8.125 7.14562 8.125 5.9375C8.125 4.72938 7.14562 3.75 5.9375 3.75C4.72938 3.75 3.75 4.72938 3.75 5.9375C3.75 7.14562 4.72938 8.125 5.9375 8.125Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0625 16.25C15.2706 16.25 16.25 15.2706 16.25 14.0625C16.25 12.8544 15.2706 11.875 14.0625 11.875C12.8544 11.875 11.875 12.8544 11.875 14.0625C11.875 15.2706 12.8544 16.25 14.0625 16.25Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18639_3226">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
